<template>
  <div class="navbar">
    <router-link to="/" style="font-size:24px;font-weight: bold;color:#333;">
      身份证二要素核验系统
    </router-link>
    <div class="right-menu" style="display: flex;">
      <template v-if="device!=='mobile'">
        <!-- <search id="header-search" class="right-menu-item" /> -->

        <!-- <error-log class="errLog-container right-menu-item hover-effect" /> -->

        <!-- <screenfull id="screenfull" class="right-menu-item hover-effect" /> -->

        <!-- <el-tooltip content="Global Size" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip> -->

      </template>
      <!-- <div v-if="is_system === 1" style="display: inline-block;margin-right:50px;font-weight: bold;font-size:14px;letter-spacing: 1px;color:#666;">
        阿里云（
        购买数：{{ current_user.al_can_num }} 次 &nbsp;&nbsp;
        已使用：{{ current_user.al_use_num }} 次 &nbsp;&nbsp;
        剩余：<span style="color: #F56C6C;">{{ current_user.al_remain_num }}</span> 次）
      </div> -->
      <div style="display: inline-block;margin-right:50px;font-weight: bold;font-size:14px;letter-spacing: 1px;">
        共计购买次数：{{ current_user.can_num }} 次 &nbsp;&nbsp;
        已使用：<span style="color: #67C23A;">{{ current_user.use_num }}</span> 次 &nbsp;&nbsp;
        <span v-if="is_system === 1">剩余可分配次数</span>
        <span v-else>剩余</span>
        ：<span style="color: #F56C6C;">{{ current_user.remain_num }}</span> 次
      </div>
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <!-- <div class="avatar-wrapper">
          <span class="avatar-name">{{ current_user.company_name }}</span>
          <i class="el-icon-caret-bottom" />
        </div> -->
        <el-button>
          {{ current_user.company_name }}<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/">
            <el-dropdown-item>&nbsp;&nbsp;&nbsp;首 页</el-dropdown-item>
          </router-link>
          <router-link v-if="is_system === 1" to="/manage">
            <el-dropdown-item>系统管理</el-dropdown-item>
          </router-link>
          <router-link to="/profile/index">
            <el-dropdown-item>修改密码</el-dropdown-item>
          </router-link>
          <!-- <a target="_blank" href="http://www.baidu.com">
            <el-dropdown-item>返回前台</el-dropdown-item>
          </a> -->
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;">&nbsp;&nbsp;&nbsp;退 出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import Breadcrumb from '@/components/Breadcrumb'
// import Hamburger from '@/components/Hamburger'
// import ErrorLog from '@/components/ErrorLog'
// import Screenfull from '@/components/Screenfull'
// import Search from '@/components/HeaderSearch'
// import MerchantLogo from './MerchantLogo'

export default {
  components: {
    // Breadcrumb,
    // Hamburger
    // ErrorLog,
    // Screenfull,
    // Search
    // MerchantLogo
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'device',
      'current_user',
      'is_system'
    ])
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.path}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  position: relative;
  padding:0px 20px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
  .hamburger-container {
    line-height: 80px;
    height: 80px;
    // float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;
    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }
  .breadcrumb-container {
    float: left;
  }
  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
  .avatar-name{
    font-size: 16px;
  }
  .right-menu {
    float: right;
    height: 100%;
    line-height: 80px;
    &:focus {
      outline: none;
    }
    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;
      &.hover-effect {
        cursor: pointer;
        transition: background .3s;
        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }
  }
}
</style>
